import { checkMovement } from "../map/Movement";
import { Point } from "../../engine/space/bounds";
import {
  Directions,
  getDirectionTowards,
  getInDirection,
} from "../../engine/space/directions";
import { Actor } from "../actors/Actor";
import { findActorForPosition, gameData } from "../GameManager";
import { addLetters } from "../words/letters";

export const wait = (actor: Actor) => {
  actor.status.waited = true;
  if (gameData.player === actor) {
    addLetters(gameData.player, 1);
    gameData.player.hunger.change(-1);
  }
  return { valid: true };
};

export const moveTo = (actor: Actor, options: { target: Point }) => {
  const dir = getDirectionTowards(actor, options.target);
  return moveTowards(actor, { dir });
};

export const moveTowards = (actor: Actor, options: { dir: Directions }) => {
  if (!checkMovement(options.dir, actor.x, actor.y)) {
    return { valid: false };
  }
  const { x, y } = getInDirection(actor, options.dir);

  if (!findActorForPosition(x, y)) {
    actor.x = x;
    actor.y = y;
  }
  actor.status.moved = true;
  return { valid: true };
};
